import apiRequest from './apiRequest';

type Response = {
  characterFileUploadURL: string;
  jobID: string;
  fileExtension: string;
};

export default async function postCharacterUploadLink(
  characterName: string,
  fileExtension: string,
) {
  return await apiRequest<Response>(
    'mogen-orchestration',
    `/characterUploadLink`,
    {
      method: 'POST',
      body: JSON.stringify({
        characterName,
        fileExtension,
      }),
    },
  );
}
